export default "__VITE_ASSET__CSyaSY8l__"